import { useMutation } from '@apollo/client';
import { useAppDispatch } from '../../app/redux/useAppSelector';
import { gql } from '../../graphql/generated/gql';
import { UIActions } from '../../ui/uiSlice';

const REQUEST_INTEGRATION = gql(/** @complexity 2 */ `
  mutation trackPlatformRequest($properties: TrackProperties!) {
    track(event: REQUEST_INTEGRATION, properties: $properties)
  }
`);

const useRequestIntegrationMutation = () => {
  const dispatch = useAppDispatch();
  const [requestIntegration] = useMutation(REQUEST_INTEGRATION);

  const request = async (label: string, website: string, detail: string) => {
    const requested = await requestIntegration({
      variables: { properties: { label, website, detail } },
    });
    if (requested) {
      dispatch(
        UIActions.pushToast({
          level: 'success',
          message: 'Integration requested',
        }),
      );
      return true;
    }
    dispatch(
      UIActions.pushToast({
        level: 'error',
        message: 'Could not request integration',
      }),
    );
    return false;
  };

  return request;
};

export default useRequestIntegrationMutation;
